<template>
  <v-menu
    :close-on-content-click="false"
    v-model="menuOpened"
    :nudge-width="450"
    max-width="600"
    transition="scale-transition"
  >
    <template v-slot:activator="{ on }">
      <v-tooltip top>
        <template v-slot:activator="{ on: onTooltip }">
          <v-btn icon
                 v-on="{ ...onTooltip, ...on }"
                 @click.stop.prevent=""
          >
            <v-icon :color="iconColor">mdi-filter-outline</v-icon>
          </v-btn>
        </template>
        <span>Filtrar por</span>
      </v-tooltip>
    </template>
    <v-card>
      <v-card-text class="text--primary">
        <v-row dense class="mt-1">
          <v-col cols="12" sm="6">
            <px-date-picker dense
                            class="required"
                            input-class="rounded-tag-small"
                            label="Data da compra inicial"
                            v-model="localDataInicial"/>
          </v-col>
          <v-col cols="12" sm="6">
            <px-date-picker dense
                            class="required"
                            input-class="rounded-tag-small"
                            label="Data da compra final"
                            v-model="localDataFinal"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12" sm="6">
            <px-date-picker dense
                            class="required"
                            input-class="rounded-tag-small"
                            label="Data da faturamento inicial"
                            v-model="localDataFaturamentoInicial"/>
          </v-col>
          <v-col cols="12" sm="6">
            <px-date-picker dense
                            class="required"
                            input-class="rounded-tag-small"
                            label="Data da faturamento final"
                            v-model="localDataFaturamentoFinal"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-comprador
              required
              dense
              class="rounded-tag-small"
              v-model="localEmpresa"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-user-comprador-multiple
              required
              dense
              label="Comprador"
              :roles="['ROLE_COMPRADOR']"
              class="rounded-tag-small"
              v-model="localResponsavel"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-produto-multiple v-model="localProduto"
                                              class="rounded-tag-small"
                                              show-details
                                              dense
                                              base-path="/produtos/page"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-centro-custo-multiple
              class="rounded-tag-small"
              dense
              v-model="localCentroCusto"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-projeto-multiple
              dense
              class="rounded-tag-small"
              v-model="localProjeto"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-grupo-multiple
              dense
              class="rounded-tag-small"
              v-model="localGrupo"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-fornecedor-multiple
              class="rounded-tag-small"
              dense
              search-in-compra
              search-by-codigo-interno
              v-model="localFornecedor"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <v-switch dense
                      hide-details
                      class="switch-dense"
                      v-model="localFilterBySaving"
                      label="Somente compras com saving"/>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="pa-3">
        <v-btn color="primary"
               class="normal-btn-text rounded-tag-small elevation-0"
               @click="emitChange">
          Aplicar
        </v-btn>
        <v-btn text class="normal-btn-text" @click="clearFilters">
          Limpar filtros
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {},
  data: () => ({
    menuOpened: false,
    localDataInicial: null,
    localDataFinal: null,
    localDataFaturamentoInicial: null,
    localDataFaturamentoFinal: null,
    localEmpresa: null,
    localCentroCusto: [],
    localProduto: [],
    localProjeto: [],
    localResponsavel: [],
    localGrupo: [],
    localFornecedor: [],
    localFilterBySaving: false,
  }),
  computed: {
    ...mapGetters('listagemCompra', ['hasCustomFilters']),
    iconColor() {
      return this.hasCustomFilters ? 'primary' : '';
    },
    empresa: {
      get() {
        return this.$store.getters['listagemCompra/empresa'];
      },
      set(empresa) {
        this.$store.dispatch('listagemCompra/empresa', empresa);
      },
    },
    centroCusto: {
      get() {
        return this.$store.getters['listagemCompra/centroCusto'];
      },
      set(centroCusto) {
        this.$store.dispatch('listagemCompra/centroCusto', centroCusto);
      },
    },
    produto: {
      get() {
        return this.$store.getters['listagemCompra/produto'];
      },
      set(produto) {
        this.$store.dispatch('listagemCompra/produto', produto);
      },
    },
    projeto: {
      get() {
        return this.$store.getters['listagemCompra/projeto'];
      },
      set(projeto) {
        this.$store.dispatch('listagemCompra/projeto', projeto);
      },
    },
    responsavel: {
      get() {
        return this.$store.getters['listagemCompra/responsavel'];
      },
      set(responsavel) {
        this.$store.dispatch('listagemCompra/responsavel', responsavel);
      },
    },
    dataFinal: {
      get() {
        return this.$store.getters['listagemCompra/dataFinal'];
      },
      set(dataFinal) {
        this.$store.dispatch('listagemCompra/dataFinal', dataFinal);
      },
    },
    dataInicial: {
      get() {
        return this.$store.getters['listagemCompra/dataInicial'];
      },
      set(dataInicial) {
        this.$store.dispatch('listagemCompra/dataInicial', dataInicial);
      },
    },
    dataFaturamentoFinal: {
      get() {
        return this.$store.getters['listagemCompra/dataFaturamentoFinal'];
      },
      set(dataFaturamentoFinal) {
        this.$store.dispatch('listagemCompra/dataFaturamentoFinal', dataFaturamentoFinal);
      },
    },
    dataFaturamentoInicial: {
      get() {
        return this.$store.getters['listagemCompra/dataFaturamentoInicial'];
      },
      set(dataFaturamentoInicial) {
        this.$store.dispatch('listagemCompra/dataFaturamentoInicial', dataFaturamentoInicial);
      },
    },
    filterBySaving: {
      get() {
        return this.$store.getters['listagemCompra/filterBySaving'];
      },
      set(filterBySaving) {
        this.$store.dispatch('listagemCompra/filterBySaving', filterBySaving);
      },
    },
    grupo: {
      get() {
        return this.$store.getters['listagemCompra/grupo'];
      },
      set(grupo) {
        this.$store.dispatch('listagemCompra/grupo', grupo);
      },
    },
    fornecedor: {
      get() {
        return this.$store.getters['listagemCompra/fornecedor'];
      },
      set(fornecedor) {
        this.$store.dispatch('listagemCompra/fornecedor', fornecedor);
      },
    },
  },
  methods: {
    emitChange() {
      this.empresa = this.localEmpresa;
      this.centroCusto = this.localCentroCusto;
      this.produto = this.localProduto;
      this.projeto = this.localProjeto;
      this.responsavel = this.localResponsavel;
      this.dataFinal = this.localDataFinal;
      this.dataInicial = this.localDataInicial;
      this.dataFaturamentoInicial = this.localDataFaturamentoInicial;
      this.dataFaturamentoFinal = this.localDataFaturamentoFinal;
      this.filterBySaving = this.localFilterBySaving;
      this.grupo = this.localGrupo;
      this.fornecedor = this.localFornecedor;
      this.$emit('change');
      this.close();
    },
    clearFilters() {
      this.localEmpresa = null;
      this.localCentroCusto = null;
      this.localProduto = null;
      this.localProjeto = null;
      this.localResponsavel = null;
      this.localDataFinal = null;
      this.localDataInicial = null;
      this.localDataFaturamentoInicial = null;
      this.localDataFaturamentoFinal = null;
      this.localFilterBySaving = false;
      this.localGrupo = null;
      this.localFornecedor = null;
      this.emitChange();
    },
    close() {
      this.menuOpened = false;
    },
  },
  created() {
    this.localEmpresa = this.empresa || null;
    this.localCentroCusto = this.centroCusto || [];
    this.localProduto = this.produto || [];
    this.localProjeto = this.projeto || [];
    this.localResponsavel = this.responsavel || [];
    this.localDataFinal = this.dataFinal || null;
    this.localDataInicial = this.dataInicial || null;
    this.localDataFaturamentoInicial = this.dataFaturamentoInicial || null;
    this.localDataFaturamentoFinal = this.dataFaturamentoFinal || null;
    this.localFilterBySaving = this.filterBySaving || false;
    this.localGrupo = this.grupo || [];
    this.localFornecedor = this.fornecedor || [];
  },
};
</script>
